import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { saveRoleFailed, saveRoleSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* saveRole(action) {
  try {
    const { id, data } = action.payload;
    const url = `${BACKEND_URL}/api/v1/user/role/${id}`;
    const dataResponse = yield makeRequest(url, data, action, 'PUT', true);
    if (dataResponse.status === OK) {
      yield put(saveRoleSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(saveRoleFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(saveRoleFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
